import React from 'react';
import { motion } from 'framer-motion';
import * as LuIcons from 'react-icons/lu';
const { LuBot, LuLineChart, LuTags, LuShieldCheck, LuWallet, LuBell } = LuIcons;
import SafeIcon from '../common/SafeIcon';

export default function Features() {
  const features = [
    { icon: LuBot, title: "AI Shopping Agent", desc: "Our AI analyzes product details, reviews, and market trends to give you personalized buying advice." },
    { icon: LuLineChart, title: "Price History & Predictions", desc: "View detailed historical pricing charts and let AI predict when the next price drop will occur." },
    { icon: LuTags, title: "Auto Coupon Finder", desc: "Stop searching for promo codes. We automatically test and apply the best coupons across the web." },
    { icon: LuShieldCheck, title: "Seller Trust Analysis", desc: "Avoid scams. We evaluate seller ratings, return policies, and shipping reliability instantly." },
    { icon: LuWallet, title: "Cashback Discovery", desc: "Never miss a reward. We aggregate cashback offers from Rakuten, Honey, and more." },
    { icon: LuBell, title: "Smart Price Alerts", desc: "Set a target price and we'll email you the second the product drops to your desired amount." }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-sm font-bold text-blue-600 tracking-wider uppercase mb-3">Powerful Capabilities</h2>
          <h3 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">Everything you need to shop smarter</h3>
          <p className="text-lg text-gray-600">Cheapo AI combines machine learning with real-time web scraping to give you an unfair advantage when shopping online.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="bg-slate-50 rounded-2xl p-8 border border-gray-100 hover:border-blue-100 hover:shadow-lg hover:shadow-blue-900/5 transition-all group"
            >
              <div className="w-12 h-12 rounded-xl bg-blue-100 text-blue-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <SafeIcon icon={feature.icon} className="text-xl" />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h4>
              <p className="text-gray-600 leading-relaxed">{feature.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}